import { reactive } from "vue";

/**
 * Composable for group checkbox selection (FL/UL groups pattern).
 * @param {Object} form - reactive form object with array fields
 * @param {import('vue').Ref<Array>} items - ref of items to select from (each has .code)
 * @param {import('vue').ComputedRef<boolean>} isDisabled - computed that disables toggling
 */
export function useGroupCheckboxes(form, items, isDisabled) {
  const expandedGroups = reactive({});

  function isGroupChecked(type) {
    const list = items.value;
    if (!Array.isArray(list) || list.length === 0) return false;
    const selected = form[type] || [];
    return list.every((i) => selected.includes(i.code));
  }

  function toggleGroup(type) {
    if (isDisabled?.value) return;

    const list = items.value;
    if (!list) return;

    const current = form[type] || [];
    const allSelected = list.every((i) => current.includes(i.code));

    if (allSelected) {
      form[type] = current.filter((p) => !list.some((i) => i.code === p));
    } else {
      const missing = list
        .filter((i) => !current.includes(i.code))
        .map((i) => i.code);
      form[type] = [...current, ...missing];
    }
  }

  function toggleItem(type, code) {
    const current = form[type] || [];
    if (current.includes(code)) {
      form[type] = current.filter((c) => c !== code);
    } else {
      form[type] = [...current, code];
    }
  }

  function toggleExpand(key) {
    expandedGroups[key] = !expandedGroups[key];
  }

  return {
    expandedGroups,
    isGroupChecked,
    toggleGroup,
    toggleItem,
    toggleExpand,
  };
}
